import { React, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  TableLayoutData,
  PageTitleComp,
} from "../../styledElements";
import { Button, PageHeader, Table, Tooltip, Progress, Tabs } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { Styled, StyledTab } from "../../../Pages/pageStyled";
import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import ParentRollView from "../../../Assets/Icons/tissue-roll-view.svg";
import OrderDrawer from "./ProductionDetailsDrawers/orderDrawer";
import ParentReelDrawer from "./ProductionDetailsDrawers/parentReelDrawer";
import {
  getFilteredProductionDetails,
  getProductionDetails,
  searchProductionDetails,
} from "../../../Services/productionPlanningServices";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import {
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";

const Panes = Tabs.TabPane;

const ProductionDetailsData = (props) => {
  const [orderSideDrawer, setOrderGradeSideDrawer] = useState(false);
  const [parentSideDrawer, setParentSideDrawer] = useState(false);
  const [reels, setReels] = useState();
  const [activeTab, setActiveTab] = useState("1");
  const [accepted, setAccepted] = useState([]);
  const [rejected, setRejected] = useState([]);
  const [currentParentReel, setCurrentParentReel] = useState();
  const [currentOrderId, setCurrentOrderId] = useState();
  const navigate = useNavigate();
  const [totalAcceptedRecords, setTotalAcceptedRecords] = useState();
  const [acceptedTableParams, setAcceptedTableParams] = useState({
    sort_by: "closing_date",
    sort_type: "descending",
    page: 1,
    size: 10,
    status: "produced",
  });
  const [currentAcceptedPage, setCurrentAcceptedPage] = useState(1);
  const [clearSearch, setClearSearch] = useState(false);
  const [totalRejectedRecords, setTotalRejectedRecords] = useState();
  const [rejectedTableParams, setRejectedTableParams] = useState({
    sort_by: "closing_date",
    sort_type: "descending",
    page: 1,
    size: 10,
    status: "rejected",
  });
  const [currentRejectedPage, setCurrentRejectedPage] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [currentTab, setCurrentTab] = useState("1");
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [searchValue, setSearchValue] = useState("");
  const [serachKey, setSearchKey] = useState(false);
  const [acceptedReelsloading, setAcceptedReelsLoading] = useState(true);
  const [rejectedReelsloading, setRejectedReelsLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [rendering, setRendering] = useState(false);
  const paginationRefForAccepted = useRef({
    sort_by: "closing_date",
    sort_type: "descending",
    page: 1,
    size: 10,
    status: "produced",
  });
  const paginationRefForRejected = useRef({
    sort_by: "closing_date",
    sort_type: "descending",
    page: 1,
    size: 10,
    status: "rejected",
  });
  const columnsHead = useRef([
    {
      title: "Parent Reel/Set No.  ",
      dataIndex: "parent_reel",
      width: "8%",
      key: "pono",
      align: "left",
      fixed: "left",
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => openParentReelDrawer(record)}
          >
            {`#${record.parent_reel}`}
          </Button>
        </div>
      ),
    },
    {
      title: "Reel No.  ",
      dataIndex: "id",
      width: "7%",
      fixed: "left",
      key: "pono",
      //align: "center",
      sorter: (a, b) =>
        a.id && b.id && a.id.toString().localeCompare(b.id.toString()),
      render: (text) => `#${text}`,
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "7%",
    //   align: "left",
    // },
    {
      title: "Order No/Stock No",
      dataIndex: "order",
      width: "10%",
      sorter: (a, b) => a.order.toString().localeCompare(b.order.toString()),
      align: "left",
      render: (text, record) =>
        record.type === "Order" ? (
          <div className="">
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => openOrderDrawer(record)}
            >
              {`#${record.order}`}
            </Button>
          </div>
        ) : (
          <div style={{ marginLeft: "12px" }}>{`#${record.order}`}</div>
        ),
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "5%",
    },
    {
      title: "Po Number",
      dataIndex: "po",
      width: "8%",
      align: "left",
      render: (text, record) => (
        <div style={{ textAlign: record.type === "Stock" ? "center" : "" }}>
          {record.po}
        </div>
      ),
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "prod_spec",
      width: "13%",
      align: "center",
    },
    {
      title: "Job Card No.",
      dataIndex: "jobcard",
      width: "7%",
      align: "left",
    },
    // {
    //   title: "Parent Reel No.  ",
    //   dataIndex: "parent_reel",
    //   width: "8%",
    //   key: "pono",
    //   align: "left",
    //   //fixed: "left",
    //   render: (text, record) => (
    //     <div className="">
    //       <Button
    //         style={{ background: "transparent" }}
    //         className="textTypeBtn textBtnIcon"
    //         onClick={() => openParentReelDrawer(record)}
    //       >
    //         {`#${record.parent_reel}`}
    //       </Button>
    //     </div>
    //   ),
    // },
    {
      title: "Size (WxL)",
      dataIndex: "size",
      width: "7%",
      align: "center",
      // render: (text, record) => `${text} ${" "} ${record.sizeUnit}`,
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "5%",
      align: "center",
    },
    {
      title: "Core Od",
      dataIndex: "core_id",
      width: "6%",
      align: "center",
      // render: (text, record) => `${text} ${" "} ${(record.units && text) ? lengthUnit[record.units.core_id]?.displayName?.toUpperCase() : "CM"}`,
    },
    {
      title: "Reel Od",
      dataIndex: "reel_od",
      width: "6%",
      align: "center",
      // render: (text, record) => `${text}`,
    },
    {
      title: "Weight",
      dataIndex: "weight",
      width: "7%",
      align: "center",
      render: (text, record) =>
        `${text} ${" "} ${
          record.units && record.units.weight
            ? capitalize(weightUnit[record.units.weight]?.displayName)
            : "T"
        }`,
    },
    {
      title: "Production Type",
      dataIndex: "production_type",
      width: "8.6%",
    },
    {
      title: "Finishing Date",
      dataIndex: "finishing_date",
      width: "8.6%",
      align: "center",
    },
    {
      title: "Finishing Shift",
      dataIndex: "finishing_shift",
      width: "10%",
      align: "center",
    },
    {
      title: "Closing Date",
      dataIndex: "closing_date",
      sorter: {
        compare: (a, b) => new Date(a.closing_date) - new Date(b.closing_date),
      },
      width: "9%",
    },
    {
      title: "Delivery Date",
      dataIndex: "order__delivery_date",
      sorter: {
        compare: (a, b) =>
          new Date(a.order__delivery_date) - new Date(b.order__delivery_date),
      },
      width: "9%",
      render: (text, record) => (
        <div style={{ textAlign: record.type === "Stock" ? "center" : "" }}>
          {record.order__delivery_date}
        </div>
      ),
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "7%",
      render: (text, record) =>
        record.type === "Order" ? (
          <div className="actionBtn">
            <Button style={{ cursor: "default" }}>
              <Iconmoon
                icon={record.priority ? "correct" : "wrong"}
                size={16}
                color={record.priority ? "#3FBD61" : "#a19f9d"}
              />
            </Button>
          </div>
        ) : (
          <div>-</div>
        ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "rejection_remarks",
      width: "8%",
      render: (text, record) =>
        record.type === "Order" ? (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={record.remarks}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon icon="message" size={16} color="#EA655B" />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ) : (
          <div>-</div>
        ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "7%",
      render: (text, record) =>
        record.type === "Order" ? (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => openOrderDrawer(record)}
                  disabled={!userDetails.roles.production.prod_details.view}
                >
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={
                  record.machine_type === "cutter"
                    ? "View details of this parent set"
                    : "View details of this parent reel"
                }
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => openParentReelDrawer(record)}
                  disabled={!userDetails.roles.production.prod_details.view}
                >
                  <img style={{ width: "20px" }} src={ParentRollView} />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ) : (
          <div>-</div>
        ),
      align: "center",
    },
  ]);
  const columnsHeadRejected = useRef([
    {
      title: "Parent Reel/Set No.",
      dataIndex: "parent_reel",
      width: "8%",
      key: "pono",
      align: "left",
      fixed: "left",
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => openParentReelDrawer(record)}
          >
            {`#${record.parent_reel}`}
          </Button>
        </div>
      ),
    },
    {
      title: "Reel No.  ",
      dataIndex: "id",
      width: "7%",
      fixed: "left",
      key: "pono",
      //align: "center",
      sorter: {
        compare: (a, b) => a.id && b.id && a.id - b.id,
      },
      render: (text) => `#${text}`,
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "7%",
    //   align: "left",
    // },
    {
      title: "Order No/Stock No",
      dataIndex: "order",
      width: "10%",
      sorter: (a, b) => a.order.toString().localeCompare(b.order.toString()),
      align: "left",
      render: (text, record) =>
        record.type === "Order" ? (
          <div className="">
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => openOrderDrawer(record)}
            >
              {`#${record.order}`}
            </Button>
          </div>
        ) : (
          <div style={{ marginLeft: "12px" }}>{`#${record.order}`}</div>
        ),
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "5%",
    },
    {
      title: "Po Number",
      dataIndex: "po",
      width: "8%",
      align: "left",
      render: (text, record) => (
        <div style={{ textAlign: record.type === "Stock" ? "center" : "" }}>
          {record.po}
        </div>
      ),
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "prod_spec",
      width: "13%",
      align: "center",
    },
    {
      title: "Job Card No.",
      dataIndex: "jobcard",
      width: "7%",
      align: "left",
    },
    // {
    //   title: "Parent Reel No.  ",
    //   dataIndex: "parent_reel",
    //   width: "8%",
    //   key: "pono",
    //   align: "left",
    //   //fixed: "left",
    //   render: (text, record) => (
    //     <div className="">
    //       <Button
    //         style={{ background: "transparent" }}
    //         className="textTypeBtn textBtnIcon"
    //         onClick={() => openParentReelDrawer(record)}
    //       >
    //         {`#${record.parent_reel}`}
    //       </Button>
    //     </div>
    //   ),
    // },
    {
      title: "Size (WxL)",
      dataIndex: "size",
      width: "6%",
      align: "center",
      // render: (text, record) => `${text} ${" "} ${record.sizeUnit}`,
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "6%",
      align: "center",
    },
    {
      title: "Core Od",
      dataIndex: "core_id",
      width: "6%",
      align: "center",
    },
    {
      title: "Reel Od",
      dataIndex: "reel_od",
      width: "6%",
      align: "center",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      width: "7%",
      align: "center",
      render: (text, record) =>
        `${text} ${" "} ${
          record.units && record.units.weight
            ? capitalize(weightUnit[record.units.weight]?.displayName)
            : "T"
        }`,
    },
    {
      title: "Production Type",
      dataIndex: "production_type",
      width: "8.6%",
    },
    {
      title: "Finishing Date",
      dataIndex: "finishing_date",
      width: "8.6%",
    },
    {
      title: "Finishing Shift",
      dataIndex: "finishing_shift",
      width: "8%",
      align: "center",
    },
    {
      title: "Closing Date",
      dataIndex: "closing_date",
      sorter: {
        compare: (a, b) => new Date(a.closing_date) - new Date(b.closing_date),
      },
      width: "9%",
    },
    {
      title: "Delivery Date",
      dataIndex: "order__delivery_date",
      sorter: {
        compare: (a, b) =>
          new Date(a.order__delivery_date) - new Date(b.order__delivery_date),
      },
      width: "9%",
      render: (text, record) => (
        <div style={{ textAlign: record.type === "Stock" ? "center" : "" }}>
          {record.order__delivery_date}
        </div>
      ),
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "6.6%",
      render: (text, record) =>
        record.type === "Order" ? (
          <div className="actionBtn">
            <Button style={{ cursor: "default" }}>
              <Iconmoon
                icon={record.priority ? "correct" : "wrong"}
                size={16}
                color={record.priority ? "#3FBD61" : "#a19f9d"}
              />
            </Button>
          </div>
        ) : (
          <div>-</div>
        ),
      align: "center",
    },
    {
      title: "Rejection Remarks",
      dataIndex: "rejection_remarks",
      width: "8%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "7%",
      render: (text, record) =>
        record.type === "Order" ? (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View details of this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => openOrderDrawer(record)}
                  disabled={!userDetails.roles.production.prod_details.view}
                >
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={
                  record.machine_type === "cutter"
                    ? "View details of this parent set"
                    : "View details of this parent reel"
                }
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => openParentReelDrawer(record)}
                  disabled={!userDetails.roles.production.prod_details.view}
                >
                  <img style={{ width: "20px" }} src={ParentRollView} />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ) : (
          <div>-</div>
        ),
      align: "center",
    },
  ]);

  // useEffect(() => {
  //   if (appliedFilters.length)
  //     fetchAcceptedProductionDetails(acceptedTableParams);
  // }, [acceptedTableParams]);

  // useEffect(() => {
  //   if (!appliedFilters.length)
  //     fetchRejectedProductionDetails(rejectedTableParams);
  // }, [rejectedTableParams]);
  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] =
        "There are no records to show in this list. Add your first record to view details here";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] =
        "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  useEffect(() => {
    setAcceptedReelsLoading(true);
    setRejectedReelsLoading(true);
    if (rendering) {
      fetchAcceptedProductionDetails(paginationRefForAccepted.current);
      fetchRejectedProductionDetails(paginationRefForRejected.current);
      setRendering(false);
    } else if (appliedFilters.length) {
      fetchFilteredProductionDetails(
        currentTab === "1"
          ? paginationRefForAccepted.current
          : paginationRefForRejected.current
      );
    } else if (searchValue !== "") {
      currentTab === "1"
        ? getRecordsForSearchedValue(searchValue)
        : getRecordsForRejSearchedValue(searchValue);
    } else {
      fetchAcceptedProductionDetails(paginationRefForAccepted.current);
      fetchRejectedProductionDetails(paginationRefForRejected.current);
    }
  }, [
    appliedFilters,
    acceptedTableParams,
    rejectedTableParams,
    currentTab,
    rendering,
  ]);

  const refresh = () => {
    setAcceptedReelsLoading(true);
    setRejectedReelsLoading(true);
    setAccepted();
    setRejected();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  };

  const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

  const getRecordsForSearchedValue = (value) => {
    setClearSearch(false);
    searchProductionDetails(value, paginationRefForAccepted.current)
      .then((resp) => {
        setAcceptedReelsLoading(false);
        setEmptyStateLabel("search");
        const list = resp.data.data.reels.map((reel) => {
          console.log(reel);
          return {
            id: reel.id,
            order: reel[reel.reel_type].number,
            type: capitalize(reel.reel_type),
            po: reel[reel.reel_type].po ? reel[reel.reel_type].po : "-",
            prod_spec: reel[reel.reel_type].product_spec,
            jobcard: reel.jobcard,
            parent_reel: reel.parent_reel,
            // size: reel[reel.reel_type].size,
            size: reel[reel.reel_type].length
            ? `${reel[reel.reel_type].width} x ${reel[reel.reel_type].length} ${lengthUnit[
                reel[reel.reel_type].units.length
              ]?.displayName?.toUpperCase()}`
            : `${reel[reel.reel_type].width} ${lengthUnit[
                reel[reel.reel_type].units.width
              ]?.displayName?.toUpperCase()}`,
            core_id:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].core_id 
                : "-",
            reel_od:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].reel_od
                : "-",
            weight:
              reel.machine_type === "cutter"
                ? reel.accepted_weight
                  ? `${parseFloat(reel.accepted_weight).toFixed(3)}`
                  : 0.0
                : reel.weight
                ? `${parseFloat(reel.weight).toFixed(3)}`
                : 0.0,
            rewinding_date: reel.rewinding_date
              ? moment(reel.rewinding_date).format("DD MMM YYYY")
              : "-",
            rewinding_shift: reel.rewinding_shift ? reel.rewinding_shift : "-",
            cutting_date: reel.cutting_date
              ? moment(reel.cutting_date).format("DD MMM YYYY")
              : "-",
            cutting_shift: reel.cutting_shift ? reel.cutting_shift : "-",
            // grain: reel.grain? reel.grain : "-",
            grain:
              reel?.reel_type === "order"
                ? reel?.order?.grain
                  ? reel?.order?.grain
                  : "-"
                : reel?.stock?.grain
                ? reel?.stock?.grain
                : "-",
            finishing_shift: `${
              (reel.rewinding_shift ? reel.rewinding_shift : "") +
              " " +
              (reel.cutting_shift ? reel.cutting_shift : "")
            }`,
            finishing_date: `${
              (reel.rewinding_date
                ? moment(reel.rewinding_date).format("DD MMM YYYY")
                : "") +
              " " +
              (reel.cutting_date
                ? moment(reel.cutting_date).format("DD MMM YYYY")
                : "")
            }`,
            closing_date: reel.closing_date
              ? moment(reel.closing_date).format("DD MMM YYYY")
              : "-",
            order__delivery_date: reel[reel.reel_type].delivery_date
              ? moment(reel[reel.reel_type].delivery_date).format("DD MMM YYYY")
              : "",
            priority:
              reel.reel_type === "order" ? reel[reel.reel_type].priority : "-",
            remarks:
              reel.comments.length !== 0
                ? reel.comments[reel.comments.length - 1]
                : null,
            units: reel.units,
            production_type: reel.order?.intermediate_reels
              ? "Intermediate Production"
              : "Finished Production",
            sizeUnit:
              reel[reel.reel_type]?.units && reel[reel.reel_type]?.units?.width
                ? lengthUnit[
                    reel[reel.reel_type].units.width
                  ]?.displayName?.toUpperCase()
                : "CM",
          };
        });
        setAccepted(list);
        setTotalAcceptedRecords(resp.data.data.total_reels);
      })
      .catch((error) => {
        console.log("Error in searching:", error);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  const getRecordsForRejSearchedValue = (value) => {
    setClearSearch(false);
    searchProductionDetails(value, paginationRefForRejected.current)
      .then((resp) => {
        setRejectedReelsLoading(false);
        setEmptyStateLabel("search");
        const list = resp.data.data.reels.map((reel) => {
          return {
            id: reel.id,
            order: reel[reel.reel_type].number,
            type: capitalize(reel.reel_type),
            po: reel[reel.reel_type].po ? reel[reel.reel_type].po : "-",
            prod_spec: reel[reel.reel_type].product_spec,
            jobcard: reel.jobcard,
            parent_reel: reel.parent_reel,
            size: reel[reel.reel_type].length
            ? `${reel[reel.reel_type].width} x ${reel[reel.reel_type].length} ${lengthUnit[
                reel[reel.reel_type].units.length
              ]?.displayName?.toUpperCase()}`
            : `${reel[reel.reel_type].width} ${lengthUnit[
                reel[reel.reel_type].units.width
              ]?.displayName?.toUpperCase()}`,
            core_id:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].core_id
                : "-",
            reel_od:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].reel_od 
                : "-",
            weight: reel.rejected_weight
              ? `${parseFloat(reel.rejected_weight).toFixed(3)}`
              : 0.0,
            rewinding_date: reel.rewinding_date
              ? moment(reel.rewinding_date).format("DD MMM YYYY")
              : "-",
            rewinding_shift: reel.rewinding_shift ? reel.rewinding_shift : "-",
            cutting_date: reel.cutting_date
              ? moment(reel.cutting_date).format("DD MMM YYYY")
              : "-",
            cutting_shift: reel.cutting_shift ? reel.cutting_shift : "-",
            // grain: reel.grain? reel.grain : "-",
            grain:
              reel?.reel_type === "order"
                ? reel?.order?.grain
                  ? reel?.order?.grain
                  : "-"
                : reel?.stock?.grain
                ? reel?.stock?.grain
                : "-",
            finishing_shift: `${
              (reel.rewinding_shift ? reel.rewinding_shift : "") +
              " " +
              (reel.cutting_shift ? reel.cutting_shift : "")
            }`,
            finishing_date: `${
              (reel.rewinding_date
                ? moment(reel.rewinding_date).format("DD MMM YYYY")
                : "") +
              " " +
              (reel.cutting_date
                ? moment(reel.cutting_date).format("DD MMM YYYY")
                : "")
            }`,
            closing_date: reel.closing_date
              ? moment(reel.closing_date).format("DD MMM YYYY")
              : "-",
            order__delivery_date: reel[reel.reel_type].delivery_date
              ? moment(reel[reel.reel_type].delivery_date).format("DD MMM YYYY")
              : "",
            priority:
              reel.reel_type === "order" ? reel[reel.reel_type].priority : "-",
            remarks:
              reel.comments.length !== 0
                ? reel.comments[reel.comments.length - 1]
                : null,
            units: reel.units,
            production_type: reel.production_type,
          };
        });
        setRejected(list);
        setTotalRejectedRecords(resp.data.data.total_reels);
      })
      .catch((error) => {
        console.log("Error in searching:", error);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  const applyfilter = (filter) => {
    if (currentTab === "1") {
      columnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    } else {
      columnsHeadRejected.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    setRejectedTableParams({
      sort_by: "closing_date",
      sort_type: "descending",
      page: 1,
      size: 10,
      status: "rejected",
    });
    setAcceptedTableParams({
      sort_by: "closing_date",
      sort_type: "descending",
      page: 1,
      size: 10,
      status: "produced",
    });
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "customer":
        const value =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Customer",
          operand: "equals",
          value,
          // tooltip: customerToolTip,
        };
      case "order_type":
        const typeValue =
          item.order_type === "reel"
            ? "Reel"
            : item.order_type === "sheet"
            ? "Sheet"
            : "Reel, Sheet";
        return {
          type: item.type,
          formattedType: "Order Type",
          operand: "equals",
          value: typeValue,
          // tooltip: `Order Type equals ${typeValue}`,
        };
      case "shift":
        const shiftValue =
          item.shifts.length > 1
            ? `${item.shifts[0]} or ${item.shifts.length - 1} others`
            : `${item.shifts[0]}`;
        // const shiftTooltip = `Shift equals ${item.shifts.join(" or ")}`;
        return {
          type: item.type,
          formattedType: "Shift",
          operand: "equals",
          value: shiftValue,
          // tooltip: shiftTooltip,
        };
      case "priority":
        const priorityValue =
          item.priority === "yes"
            ? "Yes"
            : item.priority === "no"
            ? "No"
            : "Yes or No";
        return {
          type: item.type,
          formattedType: "Priority",
          operand: "equals",
          value: priorityValue,
          // tooltip: `Priority equals ${priorityValue}`,
        };
      case "jobcard":
        const jobcardValue = item.jobcard;
        return {
          type: item.type,
          formattedType: "Job Card No",
          operand: "equals",
          value: jobcardValue,
          // tooltip: `Job Card No equals ${jobcardValue}`,
        };
      case "closing_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Closing date",
          operand: dateOperand,
          value: dateValue,
        };
      case "delivery_date":
        let deliveryDateOperand = "";
        let deliveryDateValue = "";
        if (item.start_date === item.end_date) {
          deliveryDateOperand = "-";
          deliveryDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          deliveryDateOperand = "between";
          deliveryDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Delivery date",
          operand: deliveryDateOperand,
          value: deliveryDateValue,
        };
      case "rewinding_date":
        let rewindingDateOperand = "";
        let rewindingDateValue = "";
        if (item.start_date === item.end_date) {
          rewindingDateOperand = "-";
          rewindingDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          rewindingDateOperand = "between";
          rewindingDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Rewinding date",
          operand: rewindingDateOperand,
          value: rewindingDateValue,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${
                item.grades.length - 1
              } others`
            : `${item.grades[0].grade}` +
              (item.grades[0].qualities?.length
                ? `"(${item.grades[0].qualities.join()})"`
                : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
        };
      case "gsm":
        const gsmValue =
          item.operator === "in_range"
            ? `${item.min_gsm} and ${item.max_gsm}`
            : `${item.gsm}`;
        const gsmOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
          // tooltip: `GSM ${gsmOperand} ${gsmValue}`,
        };
      case "burst_factor":
        const bfValue =
          item.operator === "in_range"
            ? `${item.min_burst_factor} and ${item.max_burst_factor}`
            : `${item.burst_factor}`;
        const bfOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Burst factor",
          operand: bfOperand,
          value: bfValue,
          // tooltip: `Burst factor ${bfOperand} ${bfValue}`,
        };
      case "reel_od":
        const reelOdValue =
          item.operator === "in_range"
            ? `${item.min_reel_od} and ${item.max_reel_od}`
            : `${item.reel_od}`;
        const reelOdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Reel OD",
          operand: reelOdOperand,
          value: reelOdValue,
          // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`,
        };
      case "core_id":
        const coreIdValue =
          item.operator === "in_range"
            ? `${item.min_core_id} and ${item.max_core_id}`
            : `${item.core_id}`;
        const coreIdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Core ID",
          operand: coreIdOperand,
          value: coreIdValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`,
        };
      case "size":
        const sizeValue =
          item.operator === "in_range"
            ? `${item.min_size} and ${item.max_size}`
            : `${item.size}`;
        const sizetype =
          item.size_type === "width"
            ? "Width"
            : item.size_type === "length"
            ? "Length"
            : "Width / Length";
        const sizeOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equals"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: sizetype,
          operand: sizeOperand,
          value: sizeValue,
          // tooltip: `${sizetype} ${sizeOperand} ${sizeValue}`,
        };
    }
    console.log("Item in format", item);
  };

  const removeFilter = (filter) => {
    if (currentTab === "1") {
      setAcceptedReelsLoading(true);
      columnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
    } else {
      setRejectedReelsLoading(true);
      columnsHeadRejected.current?.map((item) => {
        item["sortOrder"] = null;
      });
    }
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    setRendering(true);
    setSearchValue("");
    setClearSearch(true);
  };

  const fetchAcceptedProductionDetails = (params) => {
    getProductionDetails(params)
      .then((resp) => {
        if (!resp.data.data.reels.length) {
          setEmptyStateLabel("noData");
        }
        const list = resp.data.data.reels.map((reel) => {
          return {
            id: reel.id,
            groupno: reel[reel.reel_type]?.split_group
              ? reel[reel.reel_type].split_group
              : "-",
            order: reel[reel.reel_type].number,
            type: capitalize(reel.reel_type),
            po: reel[reel.reel_type].po ? reel[reel.reel_type].po : "-",
            prod_spec: reel[reel.reel_type].product_spec,
            jobcard: reel.jobcard,
            parent_reel: reel.parent_reel,
            size: reel[reel.reel_type].length
            ? `${reel[reel.reel_type].width} x ${reel[reel.reel_type].length} ${lengthUnit[
                reel[reel.reel_type].units.length
              ]?.displayName?.toUpperCase()}`
            : `${reel[reel.reel_type].width} ${lengthUnit[
                reel[reel.reel_type].units.width
              ]?.displayName?.toUpperCase()}`,
            core_id:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].core_id 
                : "-",
            reel_od:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].reel_od
                : "-",
            weight:
              reel.machine_type === "cutter"
                ? reel.accepted_weight
                  ? `${parseFloat(reel.accepted_weight).toFixed(3)}`
                  : 0.0
                : reel.weight
                ? `${parseFloat(reel.weight).toFixed(3)}`
                : 0.0,
            rewinding_date: reel.rewinding_date
              ? moment(reel.rewinding_date).format("DD MMM YYYY")
              : "-",
            rewinding_shift: reel.rewinding_shift ? reel.rewinding_shift : "-",
            cutting_date: reel.cutting_date
              ? moment(reel.cutting_date).format("DD MMM YYYY")
              : "-",
            cutting_shift: reel.cutting_shift ? reel.cutting_shift : "-",
            grain:
              reel?.reel_type === "order"
                ? reel?.order?.grain
                  ? reel?.order?.grain
                  : "-"
                : reel?.stock?.grain
                ? reel?.stock?.grain
                : "-",
            finishing_shift: `${
              (reel.rewinding_shift ? reel.rewinding_shift : "") +
              " " +
              (reel.cutting_shift ? reel.cutting_shift : "")
            }`,
            finishing_date: `${
              (reel.rewinding_date
                ? moment(reel.rewinding_date).format("DD MMM YYYY")
                : "") +
              " " +
              (reel.cutting_date
                ? moment(reel.cutting_date).format("DD MMM YYYY")
                : "")
            }`,
            closing_date: reel.closing_date
              ? moment(reel.closing_date).format("DD MMM YYYY")
              : "-",
            order__delivery_date: reel[reel.reel_type].delivery_date
              ? moment(reel[reel.reel_type].delivery_date).format("DD MMM YYYY")
              : "-",
            priority:
              reel.reel_type === "order" ? reel[reel.reel_type].priority : "-",
            remarks:
              reel.comments.length !== 0
                ? reel.comments[reel.comments.length - 1]
                : null,
            units: reel.units,
            production_type: reel.order?.intermediate_reels
              ? "Intermediate Production"
              : "Finished Production",
            sizeUnit:
              reel[reel.reel_type]?.units && reel[reel.reel_type]?.units?.width
                ? lengthUnit[
                    reel[reel.reel_type].units.width
                  ]?.displayName?.toUpperCase()
                : "CM",
          };
        });
        setAccepted(list);
        setTotalAcceptedRecords(resp.data.data.total_reels);
        setAcceptedReelsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAcceptedReelsLoading(false);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  const fetchRejectedProductionDetails = (params) => {
    getProductionDetails(params)
      .then((resp) => {
        if (!resp.data.data.reels.length) {
          setEmptyStateLabel("noData");
        }
        const list = resp.data.data.reels.map((reel) => {
          return {
            id: reel.id,
            groupno: reel[reel.reel_type]?.split_group
              ? reel[reel.reel_type].split_group
              : "-",
            order: reel[reel.reel_type].number,
            type: capitalize(reel.reel_type),
            po: reel[reel.reel_type].po ? reel[reel.reel_type].po : "-",
            prod_spec: reel[reel.reel_type].product_spec,
            jobcard: reel.jobcard,
            parent_reel: reel.parent_reel,
            size: reel[reel.reel_type].length
            ? `${reel[reel.reel_type].width} x ${reel[reel.reel_type].length} ${lengthUnit[
                reel[reel.reel_type].units.length
              ]?.displayName?.toUpperCase()}`
            : `${reel[reel.reel_type].width} ${lengthUnit[
                reel[reel.reel_type].units.width
              ]?.displayName?.toUpperCase()}`,
            core_id:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].core_id 
                : "-",
            reel_od:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].reel_od
                : "-",
            weight:
              reel.machine_type === "cutter"
                ? reel.rejected_weight
                  ? `${parseFloat(reel.rejected_weight).toFixed(3)}`
                  : 0.0
                : reel.weight
                ? `${parseFloat(reel.weight).toFixed(3)}`
                : 0.0,
            rewinding_date: reel.rewinding_date
              ? moment(reel.rewinding_date).format("DD MMM YYYY")
              : "-",
            rewinding_shift: reel.rewinding_shift ? reel.rewinding_shift : "-",
            cutting_date: reel.cutting_date
              ? moment(reel.cutting_date).format("DD MMM YYYY")
              : "-",
            cutting_shift: reel.cutting_shift ? reel.cutting_shift : "-",
            // grain: reel.grain? reel.grain : "-",
            grain:
              reel?.reel_type === "order"
                ? reel?.order?.grain
                  ? reel?.order?.grain
                  : "-"
                : reel?.stock?.grain
                ? reel?.stock?.grain
                : "-",
            finishing_shift: `${
              (reel.rewinding_shift ? reel.rewinding_shift : "") +
              " " +
              (reel.cutting_shift ? reel.cutting_shift : "")
            }`,
            finishing_date: `${
              (reel.rewinding_date
                ? moment(reel.rewinding_date).format("DD MMM YYYY")
                : "") +
              " " +
              (reel.cutting_date
                ? moment(reel.cutting_date).format("DD MMM YYYY")
                : "")
            }`,
            closing_date: reel.closing_date
              ? moment(reel.closing_date).format("DD MMM YYYY")
              : "-",
            order__delivery_date: reel[reel.reel_type].delivery_date
              ? moment(reel[reel.reel_type].delivery_date).format("DD MMM YYYY")
              : "-",
            priority:
              reel.reel_type === "order" ? reel[reel.reel_type].priority : "-",
            remarks:
              reel.comments.length !== 0
                ? reel.comments[reel.comments.length - 1]
                : null,
            units: reel.units,
            production_type: reel.order?.intermediate_reels
              ? "Intermediate Production"
              : "Finished Production",
            sizeUnit:
              reel[reel.reel_type]?.units && reel[reel.reel_type]?.units?.width
                ? lengthUnit[
                    reel[reel.reel_type].units.width
                  ]?.displayName?.toUpperCase()
                : "CM",
          };
        });
        setRejected(list);
        setTotalRejectedRecords(resp.data.data.total_reels);
        setRejectedReelsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setRejectedReelsLoading(false);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  const fetchFilteredProductionDetails = (params) => {
    const setList = params.status === "rejected" ? setRejected : setAccepted;
    const setTotal =
      params.status === "rejected"
        ? setTotalRejectedRecords
        : setTotalAcceptedRecords;
    getFilteredProductionDetails(params, appliedFilters)
      .then((resp) => {
        setRejectedReelsLoading(false);
        setAcceptedReelsLoading(false);
        setEmptyStateLabel("filter");
        // console.log(resp);
        const list = resp.data.data.reels.map((reel) => {
          let weight_key;
          if (params.status === "produced") {
            weight_key =
              reel.machine_type === "cutter"
                ? reel.accepted_weight
                  ? `${parseFloat(reel.accepted_weight).toFixed(3)}`
                  : 0.0
                : reel.weight
                ? `${parseFloat(reel.weight).toFixed(3)}`
                : 0.0;
          } else {
            weight_key =
              reel.machine_type === "cutter"
                ? reel.rejected_weight
                  ? `${parseFloat(reel.rejected_weight).toFixed(3)}`
                  : 0.0
                : reel.weight
                ? `${parseFloat(reel.weight).toFixed(3)}`
                : 0.0;
          }
          return {
            id: reel.id,
            groupno: reel[reel.reel_type]?.split_group
              ? reel[reel.reel_type].split_group
              : "-",
            order: reel[reel.reel_type].number,
            type: capitalize(reel.reel_type),
            po: reel[reel.reel_type].po ? reel[reel.reel_type].po : "-",
            prod_spec: reel[reel.reel_type].product_spec,
            jobcard: reel.jobcard,
            parent_reel: reel.parent_reel,
            size: reel[reel.reel_type].length
            ? `${reel[reel.reel_type].width} x ${reel[reel.reel_type].length} ${lengthUnit[
                reel[reel.reel_type].units.length
              ]?.displayName?.toUpperCase()}`
            : `${reel[reel.reel_type].width} ${lengthUnit[
                reel[reel.reel_type].units.width
              ]?.displayName?.toUpperCase()}`,
            core_id:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].core_id 
                : "-",
            reel_od:
              reel.machine_type !== "cutter"
                ? reel[reel.reel_type].reel_od
                : "-",
            weight: weight_key,
            rewinding_date: reel.rewinding_date
              ? moment(reel.rewinding_date).format("DD MMM YYYY")
              : "-",
            rewinding_shift: reel.rewinding_shift ? reel.rewinding_shift : "-",
            cutting_date: reel.cutting_date
              ? moment(reel.cutting_date).format("DD MMM YYYY")
              : "-",
            cutting_shift: reel.cutting_shift ? reel.cutting_shift : "-",
            grain:
              reel?.reel_type === "order"
                ? reel?.order?.grain
                  ? reel?.order?.grain
                  : "-"
                : reel?.stock?.grain
                ? reel?.stock?.grain
                : "-",
            // grain: reel.grain? reel.grain : "-",
            finishing_shift: `${
              (reel.rewinding_shift ? reel.rewinding_shift : "") +
              " " +
              (reel.cutting_shift ? reel.cutting_shift : "")
            }`,
            finishing_date: `${
              (reel.rewinding_date
                ? moment(reel.rewinding_date).format("DD MMM YYYY")
                : "") +
              " " +
              (reel.cutting_date
                ? moment(reel.cutting_date).format("DD MMM YYYY")
                : "")
            }`,
            closing_date: reel.closing_date
              ? moment(reel.closing_date).format("DD MMM YYYY")
              : "-",
            order__delivery_date: reel[reel.reel_type].delivery_date
              ? moment(reel[reel.reel_type].delivery_date).format("DD MMM YYYY")
              : "-",
            priority:
              reel.reel_type === "order" ? reel[reel.reel_type].priority : "-",
            remarks:
              reel.comments.length !== 0
                ? reel.comments[reel.comments.length - 1]
                : null,
            units: reel.units,
            sizeUnit:
              reel[reel.reel_type]?.units && reel[reel.reel_type]?.units?.width
                ? lengthUnit[
                    reel[reel.reel_type].units.width
                  ]?.displayName?.toUpperCase()
                : "CM",
          };
        });
        setList(list);
        setTotal(resp.data.data.total_reels);
      })
      .catch((err) => {
        console.log(err);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  const onAcceptedChange = (pagination, filters, sorter, extra, orderState) => {
    setAcceptedReelsLoading(true);
    columnsHead.current?.map((item) => {
      if (item.dataIndex !== sorter?.field) {
        item["sortOrder"] = null;
      }
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
    if (
      sorter.field &&
      (paginationRefForAccepted.current.sort_type !== tempSort ||
        paginationRefForAccepted.current.sort_by !== sorter.field)
    ) {
      setClearSearch(true);
      setCurrentAcceptedPage(1);
      setAcceptedTableParams({
        ...acceptedTableParams,
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      });
      paginationRefForAccepted.current = {
        ...acceptedTableParams,
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      };
    } else {
      setCurrentAcceptedPage(pagination.current);
      setAcceptedTableParams({
        ...acceptedTableParams,
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.field || "closing_date",
        sort_type: tempSort,
      });
      paginationRefForAccepted.current = {
        ...acceptedTableParams,
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.field || "closing_date",
        sort_type: tempSort,
      };
    }
  };

  const onRejectedChange = (pagination, filters, sorter) => {
    setRejectedReelsLoading(true);
    columnsHeadRejected.current?.map((item) => {
      if (item.dataIndex !== sorter?.field) {
        item["sortOrder"] = null;
      }
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
    if (
      sorter.field &&
      (paginationRefForRejected.current.sort_type !== tempSort ||
        paginationRefForRejected.current.sort_by !== sorter.field)
    ) {
      setClearSearch(true);
      setCurrentRejectedPage(1);
      setRejectedTableParams({
        ...rejectedTableParams,
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      });
      paginationRefForRejected.current = {
        ...rejectedTableParams,
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      };
    } else {
      setCurrentRejectedPage(pagination.current);
      setRejectedTableParams({
        ...rejectedTableParams,
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.field || "closing_date",
        sort_type: tempSort,
      });
      paginationRefForRejected.current = {
        ...rejectedTableParams,
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.field || "closing_date",
        sort_type: tempSort,
      };
    }
  };

  const searchAcceptedRecords = async (value = "") => {
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    setAcceptedReelsLoading(true);
    setSearchValue(value);
    if (value === "" || value === null) {
      setAppliedFilters([]);
      setFilterTags([]);
      fetchAcceptedProductionDetails(paginationRefForAccepted.current);
    } else {
      setSearchKey(true);
      getRecordsForSearchedValue(value);
    }
  };
  const searchRejectedRecords = async (value = "") => {
    columnsHeadRejected.current?.map((item) => {
      item["sortOrder"] = null;
    });
    setRejectedReelsLoading(true);
    setSearchValue(value);
    if (value === "" || value === null) {
      setAppliedFilters([]);
      setFilterTags([]);
      fetchRejectedProductionDetails(paginationRefForRejected.current);
    } else {
      setSearchKey(true);
      setClearSearch(false);
      searchProductionDetails(value, paginationRefForRejected.current)
        .then((resp) => {
          setRejectedReelsLoading(false);
          setEmptyStateLabel("search");
          const list = resp.data.data.reels.map((reel) => {
            return {
              id: reel.id,
              order: reel[reel.reel_type].number,
              type: capitalize(reel.reel_type),
              po: reel[reel.reel_type].po ? reel[reel.reel_type].po : "-",
              prod_spec: reel[reel.reel_type].product_spec,
              jobcard: reel.jobcard,
              parent_reel: reel.parent_reel,
              size: reel[reel.reel_type].length
            ? `${reel[reel.reel_type].width} x ${reel[reel.reel_type].length} ${lengthUnit[
                reel[reel.reel_type].units.length
              ]?.displayName?.toUpperCase()}`
            : `${reel[reel.reel_type].width} ${lengthUnit[
                reel[reel.reel_type].units.width
              ]?.displayName?.toUpperCase()}`,
              core_id:
                reel.machine_type !== "cutter"
                  ? reel[reel.reel_type].core_id 
                  : "-",
              reel_od:
                reel.machine_type !== "cutter"
                  ? reel[reel.reel_type].reel_od
                  : "-",
              weight:
                reel.machine_type === "cutter"
                  ? reel.rejected_weight
                    ? `${parseFloat(reel.rejected_weight).toFixed(3)}`
                    : 0.0
                  : reel.weight
                  ? `${parseFloat(reel.weight).toFixed(3)}`
                  : 0.0,
              rewinding_date: reel.rewinding_date
                ? moment(reel.rewinding_date).format("DD MMM YYYY")
                : "-",
              rewinding_shift: reel.rewinding_shift
                ? reel.rewinding_shift
                : "-",
              cutting_date: reel.cutting_date
                ? moment(reel.cutting_date).format("DD MMM YYYY")
                : "-",
              cutting_shift: reel.cutting_shift ? reel.cutting_shift : "-",
              // grain: reel.grain? reel.grain : "-",
              grain:
                reel?.reel_type === "order"
                  ? reel?.order?.grain
                    ? reel?.order?.grain
                    : "-"
                  : reel?.stock?.grain
                  ? reel?.stock?.grain
                  : "-",
              finishing_shift: `${
                (reel.rewinding_shift ? reel.rewinding_shift : "") +
                " " +
                (reel.cutting_shift ? reel.cutting_shift : "")
              }`,
              finishing_date: `${
                (reel.rewinding_date
                  ? moment(reel.rewinding_date).format("DD MMM YYYY")
                  : "") +
                " " +
                (reel.cutting_date
                  ? moment(reel.cutting_date).format("DD MMM YYYY")
                  : "")
              }`,
              closing_date: reel.closing_date
                ? moment(reel.closing_date).format("DD MMM YYYY")
                : "-",
              order__delivery_date: reel[reel.reel_type].delivery_date
                ? moment(reel[reel.reel_type].delivery_date).format(
                    "DD MMM YYYY"
                  )
                : "",
              priority:
                reel.reel_type === "order"
                  ? reel[reel.reel_type].priority
                  : "-",
              remarks:
                reel.comments.length !== 0
                  ? reel.comments[reel.comments.length - 1]
                  : null,
              units: reel.units,
              production_type: reel.order?.intermediate_reels
                ? "Intermediate Production"
                : "Finished Production",
              sizeUnit:
                reel[reel.reel_type]?.units &&
                reel[reel.reel_type]?.units?.width
                  ? lengthUnit[
                      reel[reel.reel_type].units.width
                    ]?.displayName?.toUpperCase()
                  : "CM",
            };
          });
          setRejected(list);
          setTotalRejectedRecords(resp.data.data.total_reels);
        })
        .catch((error) => {
          console.log("Error in searching:", error);
          setEmptyStateLabel("connectionAPIError");
        });
    }
  };

  const closeOrderDrawer = () => {
    setOrderGradeSideDrawer(false);
  };
  const closeParentReelDrawer = () => {
    setParentSideDrawer(false);
  };
  const openOrderDrawer = (record) => {
    setCurrentOrderId(record.order);
    setOrderGradeSideDrawer(true);
  };

  const openParentReelDrawer = (record) => {
    setCurrentParentReel(record?.parent_reel);
    setParentSideDrawer(true);
  };

  const exportHandler = (status) => {
    const currentDate = new Date();
    const today =
      currentDate.getDate() +
      "/" +
      currentDate.toLocaleString("default", { month: "long" }) +
      "/" +
      currentDate.getFullYear();
    let fileName;
    if (appliedFilters.length) {
      let status = currentTab === "1" ? "produced" : "rejected";
      fileName = status + "_reel_production_records_Kiaznn_" + today;
      const params = {
        status: status,
      };
      navigate("../production-detail/export-production-details", {
        state: {
          body: {
            status: params,
            page: "production details",
            type: "Filter",
            appliedFilters: appliedFilters,
          },
          rootPage: "../production-detail",
          fileName: fileName,
        },
      });
    } else if (!clearSearch && currentTab === "1" && serachKey) {
      let params = {
        sort_by: "closing_date",
        sort_type: "descending",
        status: "produced",
      };
      let statusParam = {
        status: "produced",
      };
      fileName = "Produced_reel_production_records_Kiaznn_" + today;
      navigate("../production-detail/export-production-details", {
        state: {
          body: {
            params: params,
            status: statusParam,
            page: "production details",
            type: "Search",
            searchValue: searchValue,
          },
          rootPage: "../production-detail",
          fileName: fileName,
        },
      });
    } else if (!clearSearch && currentTab === "2" && serachKey) {
      let params = {
        sort_by: "closing_date",
        sort_type: "descending",
        status: "rejected",
      };
      let statusParam = {
        status: "rejected",
      };
      fileName = "Rejected_reel_production_records_Kiaznn_" + today;
      navigate("../production-detail/export-production-details", {
        state: {
          body: {
            params: params,
            status: statusParam,
            page: "production details",
            type: "Search",
            searchValue: searchValue,
          },
          rootPage: "../production-detail",
          fileName: fileName,
        },
      });
    } else if (currentTab === "1") {
      const params = {
        status: "produced",
      };
      fileName = status + "_reel_production_records_Kiaznn_" + today;
      navigate("../production-detail/export-production-details", {
        state: {
          body: {
            status: params,
            page: "production details",
            type: "All Data",
          },
          rootPage: "../production-detail",
          fileName: fileName,
        },
      });
    } else {
      const params = {
        status: "rejected",
      };
      fileName = status + "_reel_production_records_Kiaznn_" + today;
      navigate("../production-detail/export-production-details", {
        state: {
          body: {
            status: params,
            page: "production details",
            type: "All Data",
          },
          rootPage: "../production-detail",
          fileName: fileName,
        },
      });
    }
  };

  const handleTabChange = (key) => {
    columnsHeadRejected.current?.map((item) => {
      item["sortOrder"] = null;
    });
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    setSearchValue("");
    setClearSearch(true);
    setCurrentTab(key);
  };

  return (
    <RightLayoutContainer>
      <PageTitleComp style={{ borderBottom: "0" }}>
        <PageHeader ghost={false} title="Production Details"></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <StyledTab>
            <Tabs onChange={handleTabChange}>
              <Panes tab="Accepted Production" key="1">
                <SearchContainer
                  placeholder={"Search Order Number or PO Number"}
                  //fetchOrder={searchOrders}
                  exportRole={accepted?.length ? true : false}
                  exportTrigger={() => exportHandler("produced")}
                  fetchOrder={searchAcceptedRecords}
                  clearSearch={clearSearch}
                  setClearSearch={setClearSearch}
                  searchedValue={searchValue}
                  filterOptions={[
                    {
                      key: 0,
                      label: "Filter by GSM",
                      value: "gsm",
                      type: "inputSelect",
                    },
                    {
                      key: 1,
                      label: "Filter by Grade/Quality",
                      value: "grade_quality",
                      type: "grade",
                    },
                    {
                      key: 2,
                      label: "Filter by Burst Factor",
                      value: "burst_factor",
                      type: "inputSelect",
                    },
                    {
                      key: 3,
                      label: "Filter by Reel OD",
                      value: "reel_od",
                      type: "inputSelect",
                      unitType: "length",
                    },
                    {
                      key: 4,
                      label: "Filter by Core ID",
                      value: "core_id",
                      type: "inputSelect",
                      unitType: "length",
                    },
                    {
                      key: 5,
                      label: "Filter by Delivery Date",
                      value: "delivery_date",
                      type: "date",
                    },
                    {
                      key: 6,
                      label: "Filter by Closing Date",
                      value: "closing_date",
                      type: "date",
                    },
                    {
                      key: 7,
                      label: "Filter by Size",
                      value: "size",
                      type: "rangeTypeSelect",
                      unitType: "length",
                    },
                    {
                      key: 8,
                      label: "Filter by Rewinding Date",
                      value: "rewinding_date",
                      type: "date",
                    },
                    {
                      key: 9,
                      label: "Filter by Shift",
                      value: "shift",
                      type: "multiSelect",
                    },
                    {
                      key: 10,
                      label: "Filter by Priority",
                      value: "priority",
                      type: "multiSelect",
                    },
                    {
                      key: 11,
                      label: "Filter by Job Card No",
                      value: "jobcard",
                      type: "input",
                    },
                  ]}
                  applyFilter={applyfilter}
                />
                {filterTags.map((filter) => (
                  <Tooltip
                    placement="bottomRight"
                    title={filter.tooltip || ""}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <span className="filter-tags">
                      <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                      &nbsp;
                      <span>{filter.formattedType}</span>
                      &nbsp;
                      <span>{filter.operand}</span>
                      &nbsp;
                      <span>{filter.value}</span>
                      <span>
                        {" "}
                        <button
                          onClick={() => {
                            removeFilter(filter);
                          }}
                        >
                          {" "}
                          <Iconmoon
                            icon="wrong"
                            size={15}
                            color="#a8a8a8"
                          />{" "}
                        </button>
                      </span>
                    </span>
                  </Tooltip>
                ))}
                {acceptedReelsloading ? (
                  <TableShimmer header={columnsHead.current} scroll={1980} />
                ) : accepted?.length ? (
                  <Table
                    columns={columnsHead.current}
                    dataSource={accepted}
                    onChange={onAcceptedChange}
                    pagination={{
                      current: currentAcceptedPage,
                      total: totalAcceptedRecords,
                      showTitle: false,
                      pageSize: paginationRefForAccepted.current.size,
                      showTotal: (total, range) =>
                        `Showing ${range[0]}-${range[1]} of ${total} results`,
                      // pageSizeOptions: [10, 20, 50, 100],
                      //showSizeChanger: true,
                    }}
                    scroll={{ x: 2100 }}
                    rowClassName={(record) =>
                      record.type === "Order" && record.priority && "true"
                    }
                  />
                ) : (
                  <EmptyState
                    img={
                      emptyStateLabel === "noData" ||
                      emptyStateLabel === "filter"
                        ? emptyState_NoData
                        : emptyStateLabel === "search"
                        ? emptyState_Search
                        : emptyState_ConnectionAPIError
                    }
                    heading={emptyStatePropsData.heading}
                    subHeading={emptyStatePropsData.subHeading}
                    label={emptyStatePropsData.label}
                    refresh={refresh}
                  />
                )}
              </Panes>
              <Panes tab="Rejected Production" key="2">
                <SearchContainer
                  placeholder={"Search Order Number or PO Number"}
                  //fetchOrder={searchOrders}
                  exportRole={(userDetails.roles.production.prod_details.view && rejectedReelsloading?.length) ? true : false}
                  exportTrigger={() => exportHandler("rejected")}
                  fetchOrder={searchRejectedRecords}
                  clearSearch={clearSearch}
                  setClearSearch={setClearSearch}
                  searchedValue={searchValue}
                  filterOptions={[
                    {
                      key: 0,
                      label: "Filter by GSM",
                      value: "gsm",
                      type: "inputSelect",
                    },
                    {
                      key: 1,
                      label: "Filter by Grade/Quality",
                      value: "grade_quality",
                      type: "grade",
                    },
                    {
                      key: 2,
                      label: "Filter by Burst Factor",
                      value: "burst_factor",
                      type: "inputSelect",
                    },
                    {
                      key: 3,
                      label: "Filter by Reel OD",
                      value: "reel_od",
                      type: "inputSelect",
                      unitType: "length",
                    },
                    {
                      key: 4,
                      label: "Filter by Core ID",
                      value: "core_id",
                      type: "inputSelect",
                      unitType: "length",
                    },
                    {
                      key: 5,
                      label: "Filter by Delivery Date",
                      value: "delivery_date",
                      type: "date",
                    },
                    {
                      key: 6,
                      label: "Filter by Closing Date",
                      value: "closing_date",
                      type: "date",
                    },
                    {
                      key: 7,
                      label: "Filter by Size",
                      value: "size",
                      type: "rangeTypeSelect",
                      unitType: "length",
                    },
                    {
                      key: 8,
                      label: "Filter by Rewinding Date",
                      value: "rewinding_date",
                      type: "date",
                    },
                    {
                      key: 9,
                      label: "Filter by Shift",
                      value: "shift",
                      type: "multiSelect",
                    },
                    {
                      key: 10,
                      label: "Filter by Priority",
                      value: "priority",
                      type: "multiSelect",
                    },
                    {
                      key: 11,
                      label: "Filter by Job Card No",
                      value: "jobcard",
                      type: "input",
                    },
                  ]}
                  applyFilter={applyfilter}
                />
                {filterTags.map((filter) => (
                  // <Tooltip
                  //   placement="bottomRight"
                  //   title={filter.tooltip || ""}
                  //   className="edit-tooltip"
                  //   getPopupContainer={(triggerNode) => triggerNode}
                  // >
                  <span className="filter-tags">
                    <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                    &nbsp;
                    <span>{filter.formattedType}</span>
                    &nbsp;
                    <span>{filter.operand}</span>
                    &nbsp;
                    <span>{filter.value}</span>
                    <span>
                      {" "}
                      <button
                        onClick={() => {
                          removeFilter(filter);
                        }}
                      >
                        {" "}
                        <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                      </button>
                    </span>
                  </span>
                  // </Tooltip>
                ))}
                {rejectedReelsloading ? (
                  <TableShimmer header={columnsHeadRejected.current} />
                ) : rejected?.length ? (
                  <Table
                    columns={columnsHeadRejected.current}
                    dataSource={rejected}
                    onChange={onRejectedChange}
                    pagination={{
                      current: currentRejectedPage,
                      total: totalRejectedRecords,
                      showTitle: false,
                      pageSize: paginationRefForRejected.current.size,
                      showTotal: (total, range) =>
                        `Showing ${range[0]}-${range[1]} of ${total} results`,
                      //pageSizeOptions: [10, 20, 50, 100],
                      //showSizeChanger: true,
                    }}
                    scroll={{ x: 2200 }}
                    rowClassName={(record) =>
                      record.type === "Order" && record.priority && "true"
                    }
                  />
                ) : (
                  <EmptyState
                    img={
                      emptyStateLabel === "noData" ||
                      emptyStateLabel === "filter"
                        ? emptyState_NoData
                        : emptyStateLabel === "search"
                        ? emptyState_Search
                        : emptyState_ConnectionAPIError
                    }
                    heading={emptyStatePropsData.heading}
                    subHeading={emptyStatePropsData.subHeading}
                    label={emptyStatePropsData.label}
                    refresh={refresh}
                  />
                )}
              </Panes>
            </Tabs>
          </StyledTab>
        </div>
      </TableLayoutData>
      <OrderDrawer
        visible={orderSideDrawer}
        id={currentOrderId}
        onCloseOrderDrawer={closeOrderDrawer}
      />
      <ParentReelDrawer
        visible={parentSideDrawer}
        id={currentParentReel}
        onCloseParentReelDrawer={closeParentReelDrawer}
      />
    </RightLayoutContainer>
  );
};
export default ProductionDetailsData;
